export default __webpack_public_path__ + "static/media/desgloseactividades.e9ad696a.png";